module.exports = {
    CarsData: () => {
      return [
        {
          "id": "avatr7",
          "name" : "Avatr 07",
          "fullname" : "Avatr 07",
          "category" : "Vehículo Eléctrico",
          "seal": require('../assets/cars/seal-001.webp'),
          "card": require('../assets/cars/avatr7-desktop.jpg'),
          "cardMobile": require('../assets/cars/avatr7-mobile.jpg'),
          "url": "./pc/avatr07/v4/index.html",
          "specs": require('../assets/svgs/specs/001-sport.svg'),
          "interactable" : true,
          "active" : true,
        },
        {
          "id": "avatr11",
          "name" : "Avatr 11",
          "fullname" : "Avatr 11",
          "category" : "Vehículo Eléctrico",
          "seal": require('../assets/cars/seal-001.webp'),
          "card": require('../assets/cars/avatr11-desktop.jpg'),
          "cardMobile": require('../assets/cars/avatr11-mobile.jpg'),
          "url": "./pc/avatr11/v1/index.html",
          "specs": require('../assets/svgs/specs/001-sport.svg'),
          "interactable" : true,
          "active" : true,
        },
      ]
    }
  }